<template>
	<div class="home">

		<div class="bana">
			<div class="section nflex">
				<div class="logo"><img src="../assets/images/11.png" /></div>
				<div class="nflex homemmenu">
					<router-link to="/index/homePage" class="ft" ><i class="iconfont icon-gonggao"></i>招标公告</router-link>
					<router-link to="/index/gongshi" class="ft" ><i class="iconfont icon-gongchengxiangmu"></i>中标公示</router-link>

					<div v-if="this.$store.getters.is_logged_in" class="fd">
					<router-link to="/index/userinfo" >您好！{{ this.$store.getters.user_info}} </router-link>


					<el-popconfirm title="确定退出登录吗？" @confirm="reqLogout()">
						<i class="iconfont icon-tuichu ttui" slot="reference" ></i>
					</el-popconfirm>

					 
					</div>

					<router-link to="/index/login" class="fd" v-else >登录</router-link>

				</div>

				<div class="mmenu"><router-link to="/index/userinfo" ><i class="iconfont icon-lianxiren"></i></router-link>
					<el-popconfirm title="确定退出登录吗？" @confirm="reqLogout()">
						<i class="iconfont icon-tuichu ttui" slot="reference" ></i>
					</el-popconfirm>
				</div>

				

				
			</div>

			<div class="section">
				<div class="bannerwd">锦西化工机械集团有限公司招标采购平台</div>
				<div class="a1">只为中标更进一步</div>
				<div class="a2">专业可靠 商机必达</div>
			</div>
    </div>

		<div class="home_main">
			<router-view ></router-view>
		</div>
	
		
		<div class="footer">
      <div class="copyright">
        <span class="zzb07tail"
          ><a href="/" class="zzb07link">锦西化工机械集团有限公司</a
          >&nbsp;&nbsp;版权所有(C)&nbsp;&nbsp;2025&nbsp;&nbsp;</span
        ><span class="zzb07tail"
          >网络支持&nbsp;&nbsp;<a
            href="http://china.chemnet.com"
            target="_blank"
            class="zzb07link"
            >中国化工网</a
          >&nbsp;&nbsp;<a
            href="http://www.chemnet.com"
            target="_blank"
            class="zzb07link"
            >全球化工网</a
          >&nbsp;&nbsp;
          <a href="http://china.toocle.com" target="_blank" class="zzb07link"
            >生意宝</a
          >&nbsp;&nbsp;<a
            href="http://www.31fabu.com"
            target="_blank"
            class="zzb07link"
            >网盛建站</a
          ></span
        >
      </div>
    </div>

	<div class="mbfor">
		<div class="tbottom"></div> 
		<div id="BottomNav">
			<ul class="clearfix" >
				<li><router-link to="/index/homePage" ><i class="iconfont icon-gonggao"></i><div>招标公告</div></router-link></li> 
				<li><router-link to="/index/gongshi" ><i class="iconfont icon-gongchengxiangmu"></i><div>中标公示</div></router-link></li>  
				<li><router-link to="/index/userinfo" ><i class="iconfont icon-lianxiren"></i><div>会员中心</div></router-link></li>    

			</ul>
		</div>
	</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex';
	export default {
		props: {},
		name: "Home",
		components: {},
		computed: {
            ...mapGetters(['user_info'])
        },
		data() {
			return {
				// islogin:false,	
				// user_name:localStorage.getItem('user_name')
				activeIndex: '1',
			};
		},
		
		mounted() {
			// let token = localStorage.getItem('token');
			// let user_name = localStorage.getItem('user_name');	
			// if(token && user_name){
			// 	this.islogin = true
			// }
			// console.log(this.user_info)
			
		},
		methods: {
			// 手机版导航
			handleSelect(key, keyPath) {
					console.log(key, keyPath);
			},
			
			
			// 登出
			async reqLogout() {
				let res = await this.req.reqLoginOut({});
				console.log(res)
				if (res.status == 200) {
					localStorage.removeItem("tb_token");
					localStorage.removeItem("tb_user_name");
					localStorage.removeItem("tempath");

					this.$store.dispatch('logout');

					this.$router.push("/index/login");
				}
			},
			
		},
	};
</script>


<style lang="less">
	@active-color: #133ab3;
	@icon-size: 16px;
	@color: #333;

	.active-color {
		color: @active-color;
	}

	.home {
		width: 100%;
		box-sizing: border-box;
		.home_main {
			width: 100%;
		}

	}

	


</style>
